/* global CCM */
import React from 'react';
import { useTranslation } from 'react-i18next';

const GDPRLinks = () => {
  const { t } = useTranslation('components');

  const onCookiesClicked = e => {
    e.preventDefault();
    CCM.openControlPanel();
  };

  return (
    <div className="h-16 flex justify-center items-center">
      <div className="text-sm">
        <a
          href="https://www.medflex.de/agb"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500"
        >
          {t('GDPRLinks.terms')}
        </a>
        <span className="mx-2">|</span>
        <a
          href="https://www.medflex.de/datenschutz"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500"
        >
          {t('GDPRLinks.privacy')}
        </a>
        <span className="mx-2">|</span>
        <a
          href="https://www.medflex.de/impressum"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500"
        >
          {t('GDPRLinks.imprint')}
        </a>
        <span className="mx-2">|</span>
        <a href="/#" onClick={onCookiesClicked} className="text-blue-500">
          {t('GDPRLinks.cookies')}
        </a>
      </div>
    </div>
  );
};

export default GDPRLinks;
